import IconButton from '@/components/view/atoms/button/IconButton'
import { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import { TextColor } from '@/components/view/atoms/text/Text'

interface Props {
  text: string
  order: 'asc' | 'desc' | undefined
  onChange(order: 'asc' | 'desc' | undefined): void
}

const ListHeaderSortButton = ({ text, order, onChange }: Props) => {
  return (
    <IconButton
      type={
        order == 'asc'
          ? IconType.ASCENDING
          : order == 'desc'
            ? IconType.DESCENDING
            : IconType.PULL_DOWN
      }
      onClick={() => onChange(order == 'asc' ? 'desc' : 'asc')}
      color={TextColor.SECONDARY}
      iconColor={order == undefined ? IconColor.DISABLED : IconColor.PRIMARY}
      text={text}
      behind
      size={12}
    />
  )
}

export default ListHeaderSortButton
